import React, { useState, useEffect } from 'react';
import styles from './CallingNoti.module.css';
import { useNavigate, useParams } from "react-router-dom";

export default function CallingNoti({ onPass, onConfirm }) {
  const navigate = useNavigate();
  const { userId, deviceUuid } = useParams();

  const basePath =
    userId && deviceUuid
      ? `/${userId}/${deviceUuid}`
      : "";

  const goTo = (path) => {
    navigate(
      basePath
        ? `${basePath}${path}`
        : path
    );
  };

  const handleDutyClick = () => {
    goTo("/user_otp_vari");
  };
  const [seconds, setSeconds] = useState(56);

  // Countdown timer for PASS button
  useEffect(() => {
    if (seconds <= 0) return;
    const timer = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [seconds]);

  const formattedTime = `00.${seconds < 10 ? `0${seconds}` : seconds}`;

  return (
    <div className={styles.screenWrapper}>
      <div className={styles.deviceFrame}>
        <div className={styles.scrollContainer}>

          {/* Main Caller Details */}
          <main className={styles.contentSection}>

            {/* Header / Caller Name */}
            <div className={styles.callerHeader}>
              <h1 className={styles.callerName}>Prathamesh Dolaskar</h1>
              <p className={styles.callStatus}>Calling you for confirmation...</p>
            </div>

            {/* Circular Glowing Map Area */}
            <div className={styles.mapCircleWrapper}>
              <div className={styles.mapCircle}>
                <div className={styles.mapOverlay}>
                  <span className={styles.locationMalang}>Malang</span>
                  <span className={styles.locationTlogomas}>Tlogomas</span>
                  <span className={styles.streetName}>Jalan Tlogomas</span>
                </div>
              </div>
            </div>

            {/* Destination Info */}
            <div className={styles.destinationGroup}>
              <h2 className={styles.goToTitle}>Go to</h2>
              <p className={styles.locationMain}>Mahajanwadi</p>
              <p className={styles.locationSub}>
                Hingna Road, Behind Mahakali Automobile
              </p>
            </div>

          </main>

          {/* Dual Action Buttons */}
          <footer className={styles.actionFooter}>
            <button
              type="button"
              className={styles.passBtn}
              onClick={onPass}
            >
              PASS ({formattedTime})
            </button>

            <button
              type="button"
              className={styles.confirmBtn}
              onClick={handleDutyClick}
            >
              Confirm
            </button>
          </footer>

        </div>
      </div>
    </div>
  );
}